import Stack from "@mui/material/Stack/Stack";

import { AdditionalFileSetWidgetData } from "@/types/additional-widget-data";
import { default as LinkComponent } from "@/features/shared/components/link/link";
import type { LegacyWidgetConfiguration } from "@/lib/api";
import useRefetchWidget from "@/features/shared/widgets/hooks/useRefetchWidget";

type Props = {
  id: string;
  data: AdditionalFileSetWidgetData;
  configuration: LegacyWidgetConfiguration;
};

const LinkSeries = ({ id, data, configuration }: Props) => {
  useRefetchWidget(id);

  const fileSet = data.data[0].data;

  return (
    <Stack gap={1} direction="column">
      {fileSet?.map((file) => (
        <LinkComponent
          href={file.url}
          key={file.name}
          name={file.name}
          config={{
            ...configuration,
            ...file,
          }}
          showTitle={false}
        />
      ))}
    </Stack>
  );
};

export default LinkSeries;
